
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"14","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.167 14h18.667A1.17 1.17 0 0021 12.833a1.17 1.17 0 00-1.166-1.166H1.167A1.17 1.17 0 000 12.833 1.17 1.17 0 001.167 14zm0-5.833h18.667A1.17 1.17 0 0021 7a1.17 1.17 0 00-1.166-1.167H1.167A1.17 1.17 0 000 7a1.17 1.17 0 001.167 1.167zM0 1.167a1.17 1.17 0 001.167 1.166h18.667A1.17 1.17 0 0021 1.167 1.17 1.17 0 0019.834 0H1.167A1.17 1.17 0 000 1.167z","fill":"#231F20"}})])
          )
        }
      }
    